import React, { useMemo } from 'react';
import { Checkbox, MenuDropdown } from '@peoplegrove/pg-components';
import { useUserFeedbackFiltersContext } from '../context/UserFeedbackFiltersContext';

const FILTER_OPTIONS = [
  { key: 'markedAsNotHelpful', label: 'Marked as not helpful' },
  { key: 'includeProductionHubs', label: 'Include production hubs' },
  { key: 'includeSuperadmin', label: 'Include Superadmin' },
  { key: 'raisedTicket', label: 'Raised ticket' },
  { key: 'flaggedInternally', label: 'Flagged internally' },
];

const UserFeedbackMoreFiltersDropdown = () => {
  const { pendingFilters, setUserFeedbackFilters } =
    useUserFeedbackFiltersContext();

  const menuItems = useMemo(
    () =>
      FILTER_OPTIONS.map(({ key, label }) => ({
        key,
        preventCloseOnClick: true,
        label: (
          <Checkbox
            checked={Boolean(pendingFilters[key])}
            onChange={checked => setUserFeedbackFilters(key, checked)}
            style={{ margin: 0 }}
          >
            {label}
          </Checkbox>
        ),
      })),
    [pendingFilters, setUserFeedbackFilters]
  );

  return (
    <MenuDropdown
      items={menuItems}
      position="bottom"
      buttonProps={{
        size: 'small',
        icon: 'pg-filter-o',
        type: 'tertiary',
      }}
    >
      Filters
    </MenuDropdown>
  );
};

export default UserFeedbackMoreFiltersDropdown;
